// extracted by mini-css-extract-plugin
export default {"main":"_404_main__H8Odf","container":"_404_container__q1YdL"};